var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg-sprite-4717975078b535c790596dd75dea4ddc.svg#icon-twitter-2461c';
                    var viewUrl = 'svg-sprite-4717975078b535c790596dd75dea4ddc.svg#view-icon-twitter-2461c';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 28 28',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };